// extracted by mini-css-extract-plugin
export var actions = "S_cQ";
export var content = "S_V";
export var headline = "S_cP";
export var imageContainer = "S_bT";
export var singleCtaContainer = "S_cM";
export var variant = "S_cN";
export var wrapper = "S_b9";